import _ from 'lodash';

import agreementIcon from './assets/agreementIcon.svg';
import arrivalsIcon from './assets/arrivalsIcon.svg';
import bookingIcon from './assets/bookingIcon.svg';
import departuresIcon from './assets/departuresIcon.svg';
import documentsIcon from './assets/documentsIcon.svg';
import earlyTerminationIcon from './assets/earlyTerminationIcon.svg';
import goCardlessIcon from './assets/goCardlessIcon.svg';
import memberInformationIcon from './assets/memberInformationIcon.svg';
import roomChangeIcon from './assets/roomChangeIcon.svg';
import schedulesIcon from './assets/schedulesIcon.svg';
import stayoversIcon from './assets/stayoversIcon.svg';
import roomHistoryIcon from './assets/roomHistoryIcon.svg';

const BOOKING_CREATED = 'booking_created';
const BOOKING_CANCELLED = 'booking_cancelled';
const BOOKING_OFFER_CREATED = 'booking_offer_created';
const SECONDARY_TENANT_ADDED = 'secondary_tenant_added';
const GUARANTOR_ADDED = 'guarantor_added';
const SECONDARY_TENANT_REMOVED = 'secondary_tenant_removed';
const GUARANTOR_REMOVED = 'guarantor_removed';
const ID_UPLOADED = 'id_uploaded';
const ID_VERIFIED = 'id_verified';
const PROOF_OF_ADDRESS_UPLOADED = 'proof_of_address_uploaded';
const ADDRESS_VERIFIED = 'address_verified';
const VISA_UPLOADED = 'visa_uploaded';
const VISA_VERIFIED = 'visa_verified';
const KYC_VERIFIED = 'kyc_verified';
const EMPLOYMENT_ADDED = 'employment_added';
const AFFORDABILITY_ASSESSED = 'affordability_assessed';
const PAYMENT_SCHEDULE_CREATED = 'payment_schedule_created';
const AGREEMENT_SIGNATURE_REQUEST_SENT = 'agreement_signature_request_sent';
const AGREEMENT_REMINDER_SENT = 'agreement_reminder_sent';
const AGREEMENT_ADDED = 'agreement_added';
const AGREEMENT_CANCELLED = 'agreement_cancelled';
const AGREEMENT_SIGNED_MANUALLY = 'agreement_signed_manually';
const LEGACY_DOCUMENT_UPLOADED = 'legacy_document_uploaded';
const LEGACY_DOCUMENT_DELETED = 'legacy_document_deleted';
const LEGACY_DOCUMENT_EDITED = 'legacy_document_edited';
const ROOM_MOVE_CREATED = 'room_move_created';
const ENTIRE_BOOKING_MOVED = 'entire_booking_moved';
const INVOICE_CREATED = 'invoice_created';
const CREDIT_NOTE_CREATED = 'credit_note_created';
const OVERPAYMENT_CREATED = 'overpayment_created';
const PAYMENT_CREATED = 'payment_created';
const REFUND_CREATED = 'refund_created';
const GOCARDLESS_PAYMENT_FOR_INVOICE_INITIATED =
  'gocardless_payment_for_invoice_initiated';
const GOCARDLESS_PAYMENT_FOR_INVOICE_CANCELLED =
  'gocardless_payment_for_invoice_cancelled';
const GOCARDLESS_PAYMENT_FOR_INVOICE_RETRIED =
  'gocardless_payment_for_invoice_retried';
const INVOICE_VOIDED = 'invoice_voided';
const CREDIT_NOTE_VOIDED = 'credit_note_voided';
const OVERPAYMENT_VOIDED = 'overpayment_voided';
const TRANSACTION_VOIDED = 'transaction_voided';
const INVOICE_SYNCED_WITH_XERO = 'invoice_synced_with_xero';
const CREDIT_NOTE_SYNCED_WITH_XERO = 'credit_note_synced_with_xero';
const PAYMENT_SYNCED_WITH_XERO = 'payment_synced_with_xero';
const REFUND_SYNCED_WITH_XERO = 'refund_synced_with_xero';
const OVERPAYMENT_SYNCED_WITH_XERO = 'overpayment_synced_with_xero';
const ADDED_XERO_ID_TO_INVOICE = 'added_xero_id_to_invoice';
const ADDED_XERO_ID_TO_CREDIT_NOTE = 'added_xero_id_to_credit_note';
const ADDED_XERO_ID_TO_PAYMENT = 'added_xero_id_to_payment';
const ADDED_XERO_ID_TO_REFUND = 'added_xero_id_to_refund';
const ADDED_XERO_ID_TO_OVERPAYMENT = 'added_xero_id_to_overpayment';
const GOCARDLESS_INVITATION_REMOVED = 'gocardless_invitation_removed';
const GOCARDLESS_INVITATION_VOIDED = 'gocardless_invitation_voided';
const GOCARDLESS_INVITATION_SENT = 'gocardless_invitation_sent';
const GOCARDLESS_INVITATION_CONNECTED = 'gocardless_invitation_connected';
const GOCARDLESS_CUSTOMER_CONNECTED = 'gocardless_customer_connected';
const GOCARDLESS_MANDATE_LINKED = 'gocardless_mandate_linked';
const GOCARDLESS_CUSTOMER_REMOVED = 'gocardless_customer_removed';
const GOCARDLESS_CUSTOMER_CANCELLED = 'gocardless_customer_cancelled';
const EARLY_TERMINATION_CREATED = 'early_termination_created';
const EARLY_TERMINATION_DELETED = 'early_termination_deleted';
const CHECK_IN_COMPLETED = 'check_in_completed';
const CHECK_OUT_COMPLETED = 'check_out_completed';
const UNDO_CHECK_IN = 'undo_check_in';
const UNDO_CHECK_OUT = 'undo_check_out';
const ROOM_CHANGE_ACCESS_GRANTED = 'room_change_access_granted';
const UNDO_ROOM_CHANGE_ACCESS_GRANTED = 'undo_room_change_access_granted';
const ROOM_CHANGE_VACATED = 'room_change_vacated';
const UNDO_ROOM_CHANGE_VACATED = 'undo_room_change_vacated';
const ROOM_CHANGE_COMPLETED = 'room_change_completed';
const UNDO_ROOM_CHANGE_COMPLETED = 'undo_room_change_completed';
const STAYOVER_COMPLETED = 'stayover_completed';
const ID_DELETED = 'id_deleted';
const PROOF_OF_ADDRESS_DELETED = 'proof_of_address_deleted';
const VISA_DELETED = 'visa_deleted';
const PROOF_OF_INCOME_UPLOADED = 'proof_of_icncome_uploaded';
const PROOF_OF_INCOME_DELETED = 'proof_of_icncome_deleted';
const PROMOTED_TO_TENANT = 'promoted_to_tenant';
const PROMOTED_TO_GUARANTOR = 'promoted_to_guarantor';
const PAYMENT_RECORDED_FROM_WEB_APP = 'payment_recorded_from_web_app';
const HOUSEKEEPING_STATUS_UPDATED = 'housekeeping_status_updated';
const OUT_OF_ORDER_CREATED = 'out_of_order_created';

interface EntryType {
  createdBy?: string;
  createdAt: string;
  action: string;
  values?: any;
  source?: string;
  cleaningStatus?: string;
  outOfServiceReason?: string;
  reason?: string;
  description?: string;
}

const getRefundActionString = (entry: EntryType) => {
  let docNumber: string;
  let docType: string;

  if (entry.values.creditNoteIdString) {
    docNumber = entry.values.creditNoteIdString;
    docType = 'CreditNote';
  } else {
    docNumber = entry.values.overpaymentIdString;
    docType = 'Overpayment';
  }

  return `Refund for ${docType} No ${docNumber} with amount ${
    entry.values.amount
  }`;
};

const getEntireBookingMovedActionString = (entry: EntryType) => {
  if (_.isNil(entry.values.oldRoomNumber)) {
    return `Entire booking moved to ${entry.values.newRoomNumber}`;
  }

  return `Entire booking moved from ${entry.values.oldRoomNumber} to ${
    entry.values.newRoomNumber
  }.`;
};

export const activityLogMapper = (entry: EntryType) => {
  switch (entry.action) {
    case BOOKING_CREATED:
      return {
        icon: bookingIcon,
        action: 'Booking created',
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PROMOTED_TO_TENANT:
      return {
        icon: bookingIcon,
        action: `${entry.values.fullName} became a member.`,
        description: `Joined by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PROMOTED_TO_GUARANTOR:
      return {
        icon: bookingIcon,
        action: `${entry.values.fullName} became a guarantor.`,
        description: `Joined by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case BOOKING_CANCELLED:
      return {
        icon: bookingIcon,
        action: 'Booking cancelled',
        description: `Cancelled by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case BOOKING_OFFER_CREATED:
      return {
        icon: bookingIcon,
        action: 'Booking Offer created',
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case SECONDARY_TENANT_ADDED:
      return {
        icon: memberInformationIcon,
        action: 'Secondary tenant added',
        description: `Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GUARANTOR_ADDED:
      return {
        icon: memberInformationIcon,
        action: 'Guarantor added',
        description: `Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case SECONDARY_TENANT_REMOVED:
      return {
        icon: memberInformationIcon,
        action: 'Secondary tenant removed',
        description: `Removed by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GUARANTOR_REMOVED:
      return {
        icon: memberInformationIcon,
        action: 'Guarantor removed',
        description: `Removed by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ID_UPLOADED:
      return {
        icon: documentsIcon,
        action: `ID "${entry.values.filename}" of ${
          entry.values.owner
        } Uploaded`,
        description: `Uploaded by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ID_VERIFIED:
      return {
        icon: documentsIcon,
        action: `ID of ${entry.values.owner} Verified`,
        description: `Verified by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ID_DELETED:
      return {
        icon: documentsIcon,
        action: `ID "${entry.values.filename}" of ${
          entry.values.owner
        } Deleted`,
        description: `Deleted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PROOF_OF_ADDRESS_UPLOADED:
      return {
        icon: documentsIcon,
        action: `Proof of Address "${entry.values.filename}" of ${
          entry.values.owner
        } Uploaded`,
        description: `Uploaded by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PROOF_OF_ADDRESS_DELETED:
      return {
        icon: documentsIcon,
        action: `Proof of Address "${entry.values.filename}" of ${
          entry.values.owner
        } Deleted`,
        description: `Deleted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ADDRESS_VERIFIED:
      return {
        icon: documentsIcon,
        action: `Address of ${entry.values.owner} Verified`,
        description: `Verified by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case VISA_UPLOADED:
      return {
        icon: documentsIcon,
        action: `Visa "${entry.values.filename}" of ${
          entry.values.owner
        } Uploaded`,
        description: `Uploaded by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case VISA_VERIFIED:
      return {
        icon: documentsIcon,
        action: `Visa of ${entry.values.owner} Verified`,
        description: `Verified by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case VISA_DELETED:
      return {
        icon: documentsIcon,
        action: `Visa "${entry.values.filename}" of ${
          entry.values.owner
        } Deleted`,
        description: `Deleted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case KYC_VERIFIED:
      return {
        icon: documentsIcon,
        action: 'KYC verified',
        description: `Verified by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PROOF_OF_INCOME_UPLOADED:
      return {
        icon: documentsIcon,
        action: `Proof of Income "${entry.values.filename}" of ${
          entry.values.owner
        } Uploaded`,
        description: `Uploaded by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PROOF_OF_INCOME_DELETED:
      return {
        icon: documentsIcon,
        action: `Proof of Income "${entry.values.filename}" of ${
          entry.values.owner
        } Deleted`,
        description: `Deleted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case EMPLOYMENT_ADDED:
      return {
        icon: documentsIcon,
        action: 'Employment added',
        description: `Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case AFFORDABILITY_ASSESSED:
      return {
        icon: documentsIcon,
        action: 'Affordability Assessed',
        description: `Assessed by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PAYMENT_SCHEDULE_CREATED:
      return {
        icon: schedulesIcon,
        action: 'Payment Schedule Created',
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case AGREEMENT_SIGNATURE_REQUEST_SENT:
      return {
        icon: agreementIcon,
        action: 'Agreement signature request sent',
        description: `Request sent by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case AGREEMENT_REMINDER_SENT:
      return {
        icon: agreementIcon,
        action: 'Agreement Reminder Sent',
        description: `Sent by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case AGREEMENT_ADDED:
      return {
        icon: agreementIcon,
        action: 'Agreement added',
        description: `Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case AGREEMENT_CANCELLED:
      return {
        icon: agreementIcon,
        action: 'Agreement Cancelled',
        description: `Cancelled by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case AGREEMENT_SIGNED_MANUALLY:
      return {
        icon: agreementIcon,
        action: 'Agreement signed manually',
        description: `Signed manually by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case LEGACY_DOCUMENT_UPLOADED:
      return {
        icon: documentsIcon,
        action: `${entry.values.legacyDocumentTitle} uploaded`,
        description: `Uploaded by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case LEGACY_DOCUMENT_DELETED:
      return {
        icon: documentsIcon,
        action: `${entry.values.legacyDocumentTitle} deleted`,
        description: `Deleted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case LEGACY_DOCUMENT_EDITED:
      return {
        icon: documentsIcon,
        action: `${entry.values.legacyDocumentTitle} edited`,
        description: `Edited by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ROOM_MOVE_CREATED:
      return {
        icon: roomChangeIcon,
        action: `Room Move from ${entry.values.oldRoomNumber} to ${
          entry.values.newRoomNumber
        } created`,
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ENTIRE_BOOKING_MOVED:
      return {
        icon: roomChangeIcon,
        action: getEntireBookingMovedActionString(entry),
        description: `Moved by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case INVOICE_CREATED:
      return {
        icon: schedulesIcon,
        action: `${entry.values.scheduleType} Invoice No ${
          entry.values.idString
        } created`,
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case CREDIT_NOTE_CREATED:
      return {
        icon: schedulesIcon,
        action: `${entry.values.scheduleType} Credit Note No ${
          entry.values.idString
        } created`,
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case OVERPAYMENT_CREATED:
      return {
        icon: schedulesIcon,
        action: `${entry.values.scheduleType} Overpayment for ${
          entry.values.amount
        } created`,
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PAYMENT_CREATED:
      return {
        icon: schedulesIcon,
        action: `${entry.values.scheduleType} Payment for Invoice No ${
          entry.values.invoiceIdString
        } with amount ${entry.values.amount} created.`,
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case REFUND_CREATED:
      return {
        icon: schedulesIcon,
        action: `${getRefundActionString(entry)} created.`,
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_PAYMENT_FOR_INVOICE_INITIATED:
      return {
        icon: schedulesIcon,
        action: `GC payment for Invoice No ${entry.values.idSting} initiated`,
        description: `Payment initiated by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_PAYMENT_FOR_INVOICE_CANCELLED:
      return {
        icon: schedulesIcon,
        action: `GC payment for Invoice No ${entry.values.idSting} cancelled`,
        description: `Payment cancelled by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_PAYMENT_FOR_INVOICE_RETRIED:
      return {
        icon: schedulesIcon,
        action: `GC payment for Invoice No ${entry.values.idSting} retried`,
        description: `Payment retried by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case INVOICE_VOIDED:
      return {
        icon: schedulesIcon,
        action: `Invoice No ${entry.values.idString} voided`,
        description: `Voided by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case CREDIT_NOTE_VOIDED:
      return {
        icon: schedulesIcon,
        action: `CreditNote No ${entry.values.idString} voided`,
        description: `Voided by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case OVERPAYMENT_VOIDED:
      return {
        icon: schedulesIcon,
        action: `Overpayment with amount ${entry.values.amount} voided`,
        description: `Voided by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case TRANSACTION_VOIDED:
      return {
        icon: schedulesIcon,
        action: `Transaction with amount ${entry.values.amount} voided`,
        description: `Voided by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case INVOICE_SYNCED_WITH_XERO:
      return {
        icon: schedulesIcon,
        action: `Invoice No ${entry.values.idString} synced with Xero`,
        description: `Synced by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case CREDIT_NOTE_SYNCED_WITH_XERO:
      return {
        icon: schedulesIcon,
        action: `CreditNote No ${entry.values.idString} synced with Xero`,
        description: `Synced by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PAYMENT_SYNCED_WITH_XERO:
      return {
        icon: schedulesIcon,
        action: `Payment with amount ${entry.values.amount} synced with Xero`,
        description: `Synced by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case REFUND_SYNCED_WITH_XERO:
      return {
        icon: schedulesIcon,
        action: `${getRefundActionString(entry)} synced.`,
        description: `Synced by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case OVERPAYMENT_SYNCED_WITH_XERO:
      return {
        icon: schedulesIcon,
        action: `Overpayment with amount ${
          entry.values.amount
        } synced with Xero`,
        description: `Synced by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ADDED_XERO_ID_TO_INVOICE:
      return {
        icon: schedulesIcon,
        action: `Xero ID ${entry.values.xeroID} added to Invoice No ${
          entry.values.idString
        }`,
        description: `ID Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ADDED_XERO_ID_TO_CREDIT_NOTE:
      return {
        icon: schedulesIcon,
        action: `Xero ID ${entry.values.xeroID} added to CreditNote No ${
          entry.values.idString
        }`,
        description: `ID Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ADDED_XERO_ID_TO_PAYMENT:
      return {
        icon: schedulesIcon,
        action: `Xero ID ${entry.values.xeroId} added to Payment with amount ${
          entry.values.amount
        } for Invoice No ${entry.values.idString}`,
        description: `ID Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ADDED_XERO_ID_TO_OVERPAYMENT:
      return {
        icon: schedulesIcon,
        action: `Xero ID ${
          entry.values.xeroId
        } added to Overpayment with amount ${entry.values.amount}`,
        description: `ID Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ADDED_XERO_ID_TO_REFUND:
      return {
        icon: schedulesIcon,
        action: `Xero ID ${
          entry.values.xeroId
        } added to ${getRefundActionString(entry)}`,
        description: `ID Added by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_INVITATION_SENT:
      return {
        icon: goCardlessIcon,
        action: `GoCardless invitation sent to ${
          entry.values.customerFullName
        }`,
        description: `Sent by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_INVITATION_VOIDED:
      return {
        icon: goCardlessIcon,
        action: `Go Cardless Invitation for ${
          entry.values.customerFullName
        } voided`,
        description: `Voided by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_INVITATION_REMOVED:
      return {
        icon: goCardlessIcon,
        action: `Go Cardless Invitation for ${
          entry.values.customerFullName
        } removed`,
        description: `Removed by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_INVITATION_CONNECTED:
      return {
        icon: goCardlessIcon,
        action: `GoCardless Invitation for ${
          entry.values.customerFullName
        } connected`,
        description: `Connected by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_CUSTOMER_CONNECTED:
      return {
        icon: goCardlessIcon,
        action: `GoCardless customer ${
          entry.values.gocardlessCustomerName
        } connected`,
        description: `Connected by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_MANDATE_LINKED:
      return {
        icon: goCardlessIcon,
        action: `GoCardless mandate ${
          entry.values.gocardlessMandateName
        } linked`,
        description: `Linked by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_CUSTOMER_REMOVED:
      return {
        icon: goCardlessIcon,
        action: `GoCardless customer ${
          entry.values.gocardlessCustomerName
        } removed`,
        description: `Removed by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case GOCARDLESS_CUSTOMER_CANCELLED:
      return {
        icon: goCardlessIcon,
        action: `GoCardless customer ${
          entry.values.gocardlessCustomerName
        } cancelled`,
        description: `Cancelled by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case EARLY_TERMINATION_CREATED:
      return {
        icon: earlyTerminationIcon,
        action: `Early Termination Created`,
        description: `Created by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case EARLY_TERMINATION_DELETED:
      return {
        icon: earlyTerminationIcon,
        action: `Early Termination Deleted`,
        description: `Deleted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case CHECK_IN_COMPLETED:
      return {
        icon: arrivalsIcon,
        action: `Check-in completed`,
        description: `Checked-in by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case CHECK_OUT_COMPLETED:
      return {
        icon: departuresIcon,
        action: `Checkout completed`,
        description: `Checked out by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case UNDO_CHECK_IN:
      return {
        icon: arrivalsIcon,
        action: 'Undo Check in',
        description: `Check in reverted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case UNDO_CHECK_OUT:
      return {
        icon: departuresIcon,
        action: 'Undo Check out',
        description: `Check out reverted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ROOM_CHANGE_ACCESS_GRANTED:
      return {
        icon: roomChangeIcon,
        action: `Room change: Access to room No ${
          entry.values.newRoomNumber
        } granted`,
        description: `Access granted by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case UNDO_ROOM_CHANGE_ACCESS_GRANTED:
      return {
        icon: roomChangeIcon,
        action: `Undo access granted to room No ${entry.values.newRoomNumber}`,
        description: `Access granted reverted by ${entry.createdBy ||
          entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ROOM_CHANGE_VACATED:
      return {
        icon: roomChangeIcon,
        action: `Room change: Room No ${entry.values.oldRoomNumber} vacated`,
        description: `Room vacated by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case UNDO_ROOM_CHANGE_VACATED:
      return {
        icon: roomChangeIcon,
        action: `Undo vacated room No ${entry.values.oldRoomNumber}`,
        description: `Room vacated reverted by ${entry.createdBy ||
          entry.source}`,
        actionDateTime: entry.createdAt
      };
    case ROOM_CHANGE_COMPLETED:
      return {
        icon: roomChangeIcon,
        action: `Room change completed`,
        description: `Completed by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case UNDO_ROOM_CHANGE_COMPLETED:
      return {
        icon: roomChangeIcon,
        action: `Undo room change completed`,
        description: `Room move completed reverted by ${entry.createdBy ||
          entry.source}`,
        actionDateTime: entry.createdAt
      };
    case STAYOVER_COMPLETED:
      return {
        icon: stayoversIcon,
        action: `Stayover completed`,
        description: `Completed by ${entry.createdBy || entry.source}`,
        actionDateTime: entry.createdAt
      };
    case PAYMENT_RECORDED_FROM_WEB_APP:
      return {
        icon: schedulesIcon,
        action: `${entry.values.scheduleType} Payment for Invoice No ${
          entry.values.invoiceIdString
        } with amount ${entry.values.amount} created.`,
        description: `Created by Web App`,
        actionDateTime: entry.createdAt
      };
    case HOUSEKEEPING_STATUS_UPDATED:
      return {
        icon: roomHistoryIcon,
        action: `Room housekeeping status has been updated to "${
          entry.values.cleaningStatus
        }"
          with reason "${entry.values.outOfServiceReason}"`,
        description: `Updated by ${entry.createdBy}`,
        actionDateTime: entry.createdAt
      };
    case OUT_OF_ORDER_CREATED:
      return {
        icon: roomHistoryIcon,
        action: `Out of Order status with reason "${
          entry.values.reason
        }", and details "${entry.values.notes}"`,
        description: `Created by ${entry.createdBy}`,
        actionDateTime: entry.createdAt
      };
    default:
      return {icon: '', action: '', description: ''};
  }
};
